<template>
  <a-carousel arrows>
    <div slot="prevArrow" class="custom-slick-arrow" style="left: 10px">
      <a-icon type="left-circle" />
    </div>
    <div slot="nextArrow" class="custom-slick-arrow" style="right: 10px">
      <a-icon type="right-circle" />
    </div>
    <img v-for="(image, index) in images" :key="index" :src="image" alt="" @click="onPreview(image)" />
  </a-carousel>
</template>
<script>
export default {
  props: {
    images: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  methods: {
    onPreview(image_url) {
      window.open(image_url);
    }
  }
};
</script>

<style scoped>
.ant-carousel >>> .custom-slick-arrow {
  width: 36px;
  height: 36px;
  font-size: 36px;
  color: #fff;
  border-radius: 50%;
  background-color: rgba(31, 45, 61, 0.11);
  opacity: 0.3;
  z-index: 1;
}
.ant-carousel >>> .custom-slick-arrow:before {
  display: none;
}
.ant-carousel >>> .custom-slick-arrow:hover {
  opacity: 0.5;
}
</style>
